import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Cohort } from '../services/cohort.service';

@Component({
  selector: 'dcc-cohort-status-cell',
  template: `<dcc-cohort-status-indicator
    [status]="cohort.status"
  ></dcc-cohort-status-indicator>`,
})
export class CohortStatusCellComponent implements ICellRendererAngularComp {
  cohort: Cohort;
  // gets called once before the renderer is used
  agInit(params: ICellRendererParams<Cohort>): void {
    this.cohort = params.data;
  }

  // gets called whenever the cell refreshes
  refresh(params: ICellRendererParams<Cohort>): boolean {
    // set value into cell again
    this.cohort = params.data;
    return true;
  }
}
